import React from 'react';
import PropTypes from 'prop-types';
import hashHistory from '@src/History';
import connection from '@src/connection';
import CommonStore from 'stores/CommonStore';

import { getMetaInfo } from 'actions/BotActions';
import {
  navToSubStory,
  navToNodeSubMenu,
  navToStep,
  navToStory,
  navToCodeStep,
  navToDynamicStep,
} from 'actions/SubstoryActions';

function getStateFromStores() {
  const meta = CommonStore.getMetaTags();
  return {
    meta,
  };
}

/**
 * Redirects to node
 * @param {string} nodeId ID of the node
 * @param {string} destination Type of the node
 */
export const redirectToNode = (nodeId, destination) => {
  getMetaInfo('node_id', nodeId, ({ meta }) => {
    if (!meta.story.id && !meta.subStory.id) {
      hashHistory.replace(`/bot/${meta.domain.id}/general-nodes`);
      return;
    }
    if (!meta.subStory.id) {
      hashHistory.replace(
        `/bot/${meta.domain.id}/${meta.story.id}/general-nodes`
      );
      return;
    }

    if (destination === 'user_responses') {
      navToNodeSubMenu(meta, 'user-says');
    } else if (destination === 'bot_responses') {
      navToNodeSubMenu(meta, 'bot-says');
    } else if (destination === 'nodes') {
      navToStep(meta);
    } else if (destination === 'code-nodes') {
      navToCodeStep(meta, 'output');
    } else if (destination === 'output-nodes') {
      navToDynamicStep(meta, 'bot-says');
    } else {
      navToSubStory(meta);
    }
  });
};

@connection([CommonStore], getStateFromStores)
class Redirector extends React.Component {
  componentDidMount() {
    const route = new URLSearchParams(this.props.location.search);
    const destination = route.get('type');
    if (destination === 'stories') {
      getMetaInfo('story', this.props.match.params.nodeName, ({ meta }) => {
        navToStory(meta);
      });
    } else if (destination === 'sub_stories') {
      getMetaInfo('subStory', this.props.match.params.nodeName, ({ meta }) => {
        navToSubStory(meta);
      });
    } else {
      redirectToNode(this.props.match.params.nodeName, destination);
    }
  }

  render() {
    return <div />;
  }
}

Redirector.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      nodeName: PropTypes.string,
    }),
  }),
};

Redirector.defaultProps = {
  location: {
    search: '',
  },
  match: {
    params: {
      nodeName: '',
    },
  },
};

export default Redirector;
